import React from 'react'

function Team() {
 return (
 <div>
 <div className="container-fluid bg-primary py-5 mb-5 hero-header">
 <div className="container">

   <div className="row justify-content-center">
 <div className="col-lg-10 text-center">
 <h1 className="display-3 text-white animated slideInDown">Guides</h1>
 <nav aria-label="breadcrumb">
 <ol className="breadcrumb justify-content-center">
 <li className="breadcrumb-item">
 <a href="/">Acceuil</a>
 </li>
 <li
 className="breadcrumb-item text-white active"
 aria-current="page"
 >
 Guides de voyages
 </li>
 </ol>
 </nav>
 </div>
 </div>
 </div>
 </div>
 {/* Team Start */}
 <div className="container-xxl py-5">
 <div className="container">
 <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
 <h6 className="section-title bg-white text-center text-primary px-3">
 Guide de Voyage
 </h6>
 <h1 className="mb-5">Rencontrez Notre Guide</h1>
 </div>
 <div className="row g-4">
 {/* <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
 <div className="team-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/team-1.jpg" alt="" />
 </div>
 <div
 className="position-relative d-flex justify-content-center"
 style={{ marginTop:"-19px" }}
 >
 <a className="btn btn-square mx-1" href="">
 <i className="fab fa-facebook-f" />
 </a>
 <a className="btn btn-square mx-1" href="">
 <i className="fab fa-twitter" />
 </a>
 <a className="btn btn-square mx-1" href="">
 <i className="fab fa-instagram" />
 </a>
 </div>
 <div className="text-center p-4">
 <h5 className="mb-0">Nom Complet</h5>
 <small>Désignation</small>
 </div>
 </div>
 </div>*/}
 <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
 <div className="team-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/chh.jpg" alt="" />
 </div>
 <div
 className="position-relative d-flex justify-content-center"
 style={{ marginTop:"-19px" }}
 >
 <a className="btn btn-square mx-1" href="">
 <i className="fab fa-facebook-f" />
 </a>
 
 
 <a className="btn btn-square mx-1" href="">
 <i className="fab fa-instagram" />
 </a>
 </div>
 <div className="text-center p-4">
 <h5 className="mb-0">Chedly Arfaoui</h5>
 <small>Désignation</small>
 </div>
 </div>
 </div>
 <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
 <div className="team-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/moez1.png" alt="" />
 </div>
 <div
 className="position-relative d-flex justify-content-center"
 style={{ marginTop:"-19px" }}
 >
 <a className="btn btn-square mx-1" href="">
 <i className="fab fa-facebook-f" />
 </a>
 <a className="btn btn-square mx-1" href="">
 <i className="fab fa-twitter" />
 </a>
 <a className="btn btn-square mx-1" href="">
 <i className="fab fa-instagram" />
 </a>
 </div>
 <div className="text-center p-4">
 <h5 className="mb-0">Moez Hattour</h5>
 <small>Désignation</small>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 {/* Team End */}
 </div>
 )
}

export default Team
